import * as c from '@chakra-ui/react'
import { MenuHamburgerIcon } from 'src/assets/icons/nav/hamburger.icon'

interface MenuTriggerProps {
  onClick?: () => void
  'aria-controls'?: string
  'aria-expanded'?: boolean
}

export const MenuTrigger = (props: MenuTriggerProps) => (
  <c.IconButton bg="black.0" aria-label="Abrir menu de navegação" {...props}>
    <MenuHamburgerIcon />
  </c.IconButton>
)
